const id_master_supplier = {
    add: "tambah pemasok",
    address: "alamat pemasok",
    edit: "ubah pemasok",
    email: "email pemasok",
    fax: "fax pemasok",
    name: "nama pemasok",
    phone: "telepon pemasok",
    pic: "PIC pemasok",
    upload: "unggah pemasok",

    form: {
        ppn_label: "Aktifkan untuk menggunakan PPN",
        upload_title: "input data pemasok",
        coa_debit: "COA Hutang",
        coa_dp: "COA Down Payment (DP)",
    },

    error: {
        create: "Gagal membuat pemasok.",
        delete: "Gagal menghapus pemasok.",
        edit: "Gagal mengubah pemasok.",
    },

    success: {
        create: "Berhasil membuat pemasok.",
        delete: "Berhasil menghapus pemasok.",
        edit: "Berhasil mengubah pemasok.",
    },
}

export default id_master_supplier;